import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import HowItWorks from '../components/landing/HowItWorks';
import Benefits from '../components/landing/Benefits';
import FinalCTA from '../components/landing/FinalCTA';
import ScrollToTop from '../components/landing/ScrollToTop';
import '../components/landing/LandingPage.css';

const LandingPage: React.FC = () => {
    return (
        <div className="landing-page">
            <main>
                <Hero />
                <Features />
                <HowItWorks />
                <Benefits />
                <FinalCTA />
            </main>
            <footer className="landing-footer">
                <div className="footer-content">
                    <div className="footer-links">
                        <Link to="/privacy">Privacy Policy</Link>
                        <Link to="/terms">Terms of Service</Link>
                    </div>
                    <div className="footer-info">
                        <p>© 2025 MailMeld. All rights reserved.</p>
                        <p>Questions? Contact us at support@mailmeld.com</p>
                    </div>
                </div>
            </footer>
            <ScrollToTop />
        </div>
    );
};

export default LandingPage;